export const cardColor = {
    'Staff': {
        background: '#d7adc5',
        border: '#db5aa4',
        toogle: '#db5aa4',
        view: '#db5aa4'
        ,
        darkBackground: '#3b2430',
        darkBorder: '#ff9ac6',
        darkToogle: '#ff9ac6',
        darkView: '#ff9ac6'
    },
    'Quality Assurance': {
        background: '#E7F5E9',
        border: '#4CAF50',
        toogle: '#4CAF50',
        view: '#4CAF50'
        ,
        darkBackground: '#14361b',
        darkBorder: '#66bb6a',
        darkToogle: '#66bb6a',
        darkView: '#66bb6a'
    },
    'Development': {
        background: '#FFF3E0',
        border: '#FF9800',
        toogle: '#FF9800',
        view: '#FF9800'
        ,
        darkBackground: '#4a2b00',
        darkBorder: '#ffb74d',
        darkToogle: '#ffb74d',
        darkView: '#ffb74d'
    },
    'UI/UX Design': {
        background: '#E1ECFC',
        border: '#5489D3',
        toogle: '#5489D3',
        view: '#5489D3'
        ,
        darkBackground: '#11283f',
        darkBorder: '#82b1ff',
        darkToogle: '#82b1ff',
        darkView: '#82b1ff'
    }
};
